import { motion } from "framer-motion";
import { useContent } from "@/context/ContentContext";
import { renderLinkedText } from "@/lib/content";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { PageSeo } from "@/components/PageSeo";
import { EnquiryForm } from "@/components/EnquiryForm";

export default function ContactPage() {
  const { content } = useContent();
  const c = content.contact_page;

  return (
    <div className="grain bg-[#FAF8F5]" data-testid="contact-page">
      <PageSeo path="/contact" />
      <Navbar />
      <main>
        <section className="bg-[#1C1917] pb-16 pt-40 lg:pt-48">
          <div className="mx-auto max-w-5xl px-6 lg:px-10">
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="mb-8 inline-flex items-center gap-3 rounded-full border border-[#FAF8F5]/25 bg-black/20 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.25em] text-[#FAF8F5]/90 backdrop-blur-md"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-[#C5A059]" />
              {c.kicker}
            </motion.p>
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="font-display text-4xl font-medium leading-[1.1] tracking-tight text-[#FAF8F5] sm:text-5xl"
              data-testid="contact-page-h1"
            >
              {renderLinkedText(c.h1)}
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.25 }}
              className="mt-6 max-w-2xl text-base leading-relaxed text-[#FAF8F5]/80 md:text-lg"
            >
              {renderLinkedText(c.intro)}
            </motion.p>
          </div>
        </section>
        <EnquiryForm />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
